<template>
  <div class="height-100">
    <!-- 导航 -->
    <loading v-if="loading"></loading>
    <div>
      <van-tabs v-model="active" animated @click="onClick">
        <van-tab v-for="(item, index) in title" :title="item" :name="index" :key="index">
          <div v-if="!loading">
            <div v-if="list.length > 0">
              <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list v-if="list.length > 0" v-model="loading2" :finished="finished" finished-text="没有更多了"
                  @load="onLoad">
                  <caka-order :list="list" @onCancelOrder="showDialog" @goPay="changePay" @Sureget="sureget"
                    @Logistics="goLogistics">
                  </caka-order>
                </van-list>
              </van-pull-refresh>
            </div>
            <van-empty description="暂无订单" v-if="showEmpty" />
            <!-- <div class="empt" v-else> -->
            <!-- <img src="@/assets/images/logo_loading.png">
              <span style="margin-top: 1rem;">暂无订单</span> -->
            <!-- </div> -->
          </div>
        </van-tab>
      </van-tabs>
      <Translate v-if="showWL" :logistics-list="logisticsList" @closed="closedadd" :active="0">
      </Translate>
    </div>
  </div>
</template>

<script>
import CakaOrder from "../../components/order/CakaOrder.vue";
export default {
  name: "AllOrder",
  props: {},
  data() {
    return {
      isLoading: false,
      showEmpty: false,
      loading: true,
      loading2: false,
      finished: false,
      logisticsList: null,
      list: [
      ],
      title: ["全部订单", "待支付", "待收货", "已完成"],
      form: {
        status: '',
        current: 1,
        size: 10,
        userId: '',
      },
      active: 1,
      showWL: false,
      userId: null,
    };
  },
  components: { CakaOrder },
  methods: {
    closedadd(val) {
      this.showWL = val
    },
    goLogistics(index) {
      let item = this.list[index]
      if (item.tripartiteOrderNo) {
        let form = {
          logisticCode: item.express_no,
          // logisticCode: '8152049085401',
          shipperCode: item.expressCode,
          customerName: item.phone,
          orderCode: this.orderNo,
        }
        this.$api
          .queryEbusiness(form)
          .then((res) => {
            if (res.code == 1) {
              this.$Toast(res.msg);
            } else {
              this.logisticsList = res.data.Traces
              this.showWL = true
            }

          })
          .catch((err) => {
            this.$Toast(err.msg);
          });
      }

    },
    sureget(index) {
      let item = this.list[index]
      this.$api
        .confirmReceipt(item.orderNo, item.productSubOrderList[0].id)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
          } else {
            this.$Toast(res.msg);
            this.onRefresh()
          }
        })
        .catch((err) => {
          this.$Toast(err.msg);
        });

    },
    changePay(index) {
      let item = this.list[index]
      this.toPay(item)
    },
    toPay(item) {
      // 统一跳转到统一支付页面，只需传订单号
      this.$router.push({
        path: "/UnifiedCashier",
        query: {
          orderNo: item.orderNo,
        },
      });
    },

    showDialog(val) {

      this.$Dialog.confirm({
        title: "提示",
        message: "是否确认取消订单？",
        confirmButtonText: '我在想想',
        cancelButtonText: '取消订单'
      })
        .then(() => {
        })
        .catch(() => {
          // on cancel
          this.cancelPayment(val)
        });
    },
    cancelPayment(val) {
      let item = this.list[val]
      if (item.orderDetail) {
        this.$api
          .cancelPayment(item.tripartiteOrderNo)
          .then((res) => {
            if (res.code == 1) {
              this.$Toast(res.msg);
            } else {
              this.$Toast(res.msg);
              this.onRefresh()
            }

          })
          .catch((err) => {
            this.$Toast(err.msg);
          });

      } else
        this.$api
          .productcancelPayment(item.orderNo)
          .then((res) => {
            if (res.code == 1) {
              this.$Toast(res.msg);
            } else {
              this.$Toast(res.msg);
              this.onRefresh()
            }

          })
          .catch((err) => {
            this.$Toast(err.msg);
          });
    },
    //	0待支付 1待发货 2已发货 3已完成 4已关闭 5超时
    onClick() {
      if (this.active == 0) {
        this.form.status = ''
      } else if (this.active == 1) {
        this.form.status = '0'
      } else if (this.active == 2) {
        this.form.status = '10'
      } else {
        this.form.status = '3'
      }
      this.list.length = 0
      this.form.current = 1
      this.loading = true
      this.finished = false,
        this.getMyOrder()
      this.$router.replace({ path: '/AllOrder', query: { active: String(this.active) } }).catch(() => {});
    },
    onRefresh() {
      this.form.current = 1
      this.getMyOrder()
    },
    onLoad() {
      this.form.current = this.form.current + 1
      this.getMyOrder()
    },
    // //   获取订单信息
    getMyOrder() {
      this.$api
        .queryOrderInfo(this.form)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
            return
          }
          if (this.form.current == 1) {
            this.list = res.data.records
          } else {
            this.list.push(...res.data.records)
          }
          if (this.form.current >= res.data.pages) {
            this.finished = true
          }

          res.data.records.length ? this.showEmpty = false : this.showEmpty = true
          this.loading = false
          this.isLoading = false
          this.loading2 = false
        })
        .catch((err) => {
          this.loading2 = false
          this.finished = true
          this.loading = false
          this.isLoading = false
        });
    },
    initView() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      this.form.userId = userInfo.id;
      this.userId = this.form.userId;
      const raw = this.$route.query.active;
      if (raw !== undefined && raw !== null && raw !== "") {
        const n = Number(raw);
        if (!Number.isNaN(n)) {
          this.active = n;
        }
      }
      if (this.active == 0) {
        this.form.status = "";
      } else if (this.active == 1) {
        this.form.status = "0";
      } else if (this.active == 2) {
        this.form.status = "10";
      } else {
        this.form.status = "3";
      }
      // 每次进入列表均从第一页重拉（支付完成从详情返回等场景需要最新状态）
      this.form.current = 1;
      this.finished = false;
      this.list = [];
      this.showEmpty = false;
      this.loading = true;
      this.loading2 = false;
      this.isLoading = false;
      this.getMyOrder();
    },
  },

  beforeRouteEnter(to, from, next) {
    to.meta.keepAlive = true;
    next();
  },

  /** keep-alive 页面：每次展示（含从订单详情/支付页返回）都刷新列表 */
  activated() {
    this.$nextTick(() => {
      this.initView();
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  },

  computed: {},
  watch: {},
};
</script>

<style lang='scss' scoped>
.empt {
  display: flex;
  flex-direction: column;
  height: 90vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: #000;
}
</style>